import React, { useState, useEffect } from 'react';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from 'recharts';
import { weeklyShareNOK } from '@api/analytics';
import { WeeklyShareNOK } from '@typings/Analytics';
import { ApiResponse } from '@typings/ApiResponse';
import { ShareNOKChartData } from '../../types';

interface WeeklyChartProps {
  partnerCarehomeId: string;
}

const WeeklyChart: React.FC<WeeklyChartProps> = ({ partnerCarehomeId }) => {
  const [weeklyData, setWeeklyData] = useState<ShareNOKChartData[]>();
  useEffect(() => {
    const getWeeklyData = async () => {
      try {
        const res: ApiResponse<WeeklyShareNOK[]> =
          await weeklyShareNOK(partnerCarehomeId);
        if (res?.data) {
          const transformedData = res.data.map(item => {
            const { week, total, nextOfKin } = item;

            const weekNumber = week.toString().slice(-2);

            return {
              name: `Week ${weekNumber}`,
              Shared: nextOfKin,
              'Not shared': total - nextOfKin,
            };
          });
          setWeeklyData(transformedData);
        }
      } catch (error) {
        console.error('Error fetching weekly data:', error);
      }
    };
    if (partnerCarehomeId) {
      getWeeklyData();
    }
  }, [partnerCarehomeId]);

  return (
    <div className="mb-10">
      <h3 className="govuk-heading-s chart-title">Weekly (last 7 weeks)</h3>
      <ResponsiveContainer width="100%" height={300}>
        <BarChart
          data={weeklyData}
          margin={{
            top: 20,
            right: 30,
            left: 20,
            bottom: 5,
          }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="name" />
          <YAxis />
          <Tooltip />
          <Legend />
          <Bar dataKey="Shared" stackId="a" fill="#005eb8" />
          <Bar dataKey="Not shared" stackId="a" fill="#d4351c" />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default WeeklyChart;
